export const RIBBON_PALETTES = {
    primary: {
        id: "primary",
        phase: [0, 102 / 255, 172 / 255],
        sweepStart: 0.39,
        sweepSpan: 0.28,
        mixAmount: 0.79,
    },
    "primary-v2": {
        /* v2 — cool-blue-forward BUT retains cyan + lime green accents. Phase
           chosen so Diality Blue #0066AC lands at t=0.5 and the sweep still
           walks through mint-teal (near #51C6A2 / #2C7682 territory) to lime
           green at t=0.72. Sweep widened 0.30 → 0.32 (starts at 0.40 now)
           to sneak in two darker samples that echo #005A9A (deeper Diality
           Blue) and Diality Deep Blue #2B3E7F territory at the low end
           without pushing lime out at the top:
           - t=0.40-0.42: deeper blue territory (#005A9A / #2B3E7F echo)
           - t=0.44-0.48: Diality Blue toward deep — #005A9A neighborhood
           - t=0.50: Diality Blue #0066AC exactly (brand anchor)
           - t=0.55: mint-teal near #51C6A2 / #2C7682
           - t=0.60: bright green (Diality Green territory)
           - t=0.65-0.72: lime green
           mixAmount 0.85 (was 0.79) shows more color depth through white. */
        id: "primary-v2",
        phase: [0, 0.2821, 0.6931],
        sweepStart: 0.4,
        sweepSpan: 0.32,
        /* mixAmount 0.90 (was 0.85) saturates the mid-band #01A6A0 territory
           (t≈0.518) so the deep teal reads as a distinct band alongside the
           Diality Blue anchor at t=0.50, and softens the visible step between
           adjacent samples so consecutive colors blend more smoothly instead
           of banding. */
        mixAmount: 0.9,
    },
    "primary-v2-landing-blue": {
        /* Landing-only Primary v2 derivative. Keeping the same phase, start, and
           mix preserves the approved colors and saturation; compressing the sweep
           from 0.32 to 0.2667 raises the blue portion of the palette window by
           approximately 20% while retaining the teal and green tail. */
        id: "primary-v2-landing-blue",
        phase: [0, 0.2821, 0.6931],
        sweepStart: 0.4,
        sweepSpan: 0.2667,
        mixAmount: 0.9,
    },
    secondary: {
        id: "secondary",
        phase: [0, 81 / 255, 140 / 255],
        sweepStart: 0.29,
        sweepSpan: 0.28,
        mixAmount: 0.79,
    },
    "secondary-v2": {
        /* v2 — full purple → indigo → royal-blue → baby-blue arc. Sweep
           widened 0.20 → 0.26 (still narrow enough that consecutive samples
           sit only ~0.013 apart in t for smooth blending), extending the
           tail from 0.44 → 0.50 so the palette walks all the way into the
           bright sky-blue / baby-blue territory the user called out
           (#00AAFC, #00B4F9, #04D1EB, #08D9E4 all land in t≈0.48-0.52).
           Deep purple entry at 0.24 preserved:
           - t=0.24: deep magenta / purple shoulder
           - t=0.28: deep purple (#43205F territory)
           - t=0.32: deep indigo → #2E2C97
           - t=0.34: royal indigo
           - t=0.36: royal blue
           - t=0.40: Diality Blue territory
           - t=0.44: bright blue
           - t=0.48-0.50: sky blue / baby blue (#00AAFC, #00B4F9)
           mixAmount stays 0.92 for punchy saturation. */
        id: "secondary-v2",
        phase: [0, 81 / 255, 140 / 255],
        sweepStart: 0.24,
        sweepSpan: 0.26,
        mixAmount: 0.92,
    },
};
//# sourceMappingURL=palettes.js.map